import { useCallback } from 'react';
import rootStore from '../../RootStore';
import GQCountrySelect from '../GQCountryMode/GQCountrySelect';
import { useNavigate, useParams } from 'react-router-dom';

const SelectCountry = () => {
    const navigate = useNavigate();
    let { nextView } = useParams();

    const onSelectCountry = useCallback((id: number) => {
        rootStore.countryStore.currentStore.overrideValues(id);
        navigate(`/${nextView}`);
    }, [navigate, nextView]);

    return <GQCountrySelect onCountrySelected={onSelectCountry} />;
};

export default SelectCountry;
